// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3S4a_","legacyBtn":"MutateMid_legacyBtn__2Df9c"};